import { Controller } from "stimulus"
import createSubscription from "../channels/task_lists_channel"

export default class extends Controller {
  connect() {
    var task_list = document.getElementById('task-lists-list');
    const projectIdValue = task_list.dataset.taskListRefreshProjectIdValue;
    this.subscription = createSubscription(projectIdValue);
  }

  disconnect(){
    if (this.subscription){
      this.subscription.unsubscribe()
    }
  }
}
